import { render, staticRenderFns } from "./usuariosAdministrativos.vue?vue&type=template&id=066cbb72"
import script from "./usuariosAdministrativos.vue?vue&type=script&lang=js"
export * from "./usuariosAdministrativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports